import { Labels } from '../../shared-components/global/labels.js';

Labels.set('ui-textcounter', 'remaining', 'Доступно символов:');
Labels.set(
    'ui-textcounter',
    'invalid',
    'Текст слишком длинный (макс. %d знаков)'
);
